var map = {
	"./01-ubuntu.js": 1047,
	"./02-debian.js": 1048,
	"./03-redhat-or-centos.js": 1049,
	"./04-freebsd.js": 1050,
	"./05-docker.js": 1051,
	"./06-macos.js": 1052,
	"./07-windows.js": 1053,
	"./08-linux.js": 1054,
	"./09-aws.js": 1330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1046;